import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react'

const root = ReactDOM.createRoot(document.getElementById('root'));
const PUBLISHABLE_KEY = "pk_test_cGF0aWVudC1weXRob24tODIuY2xlcmsuYWNjb3VudHMuZGV2JA";
if(!PUBLISHABLE_KEY){
  throw new Error('Add your Clerk publishable key to the .env.local file.')
}

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <App />
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
